export default function bulkArchiveReportInstanceDirective() {
  return {
    template: require('./bulk-archive-report-instance.html'),
    restrict: 'E',
    controller: 'BulkArchiveReportInstanceController',
    controllerAs: 'bulkArchiveReportInstanceVM',
    bindToController: true,
    replace: true,
    scope: {
      reportInstance: '=',
    },
  };
}
